import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
const filterWidth = 370;

export const advancedFilterStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            width: filterWidth,
            height: "100%",
            marginTop: 64,
        },
        customClass: {
            width: "290px",
        },
        filters: {
            width: filterWidth,
            borderRight: "1px solid #E0E0E0",
            borderRadius: "0px",
            zIndex: theme.zIndex.drawer + 1,
        },
        title: { padding: "20px" },
        icon: {
            float: "right",
            padding: "3px",

            "&:hover": {
                backgroundColor: "initial",
            },
        },
        closeFilter: {
            display: "none",
        },
        openFilter: {
            position: "fixed",
            top: "63px",
            bottom: "0",
            overflowY: "auto",
            overflowX: "hidden",
        },
        applyButton: {
            display: "inline-block !important",
            width: "120px !important",
            marginTop: "40px !important",
            height: "37px !important",
            fontWeight: "500 !important" as any,
            fontSize: "15px !important",
        },
        resetButton: {
            display: "inline-block !important",
            width: "120px !important",
            marginLeft: "40px !important",
            marginRight: "10px !important",
            marginTop: "40px !important",
            height: "37px !important",
            fontWeight: "500 !important" as any,
            fontSize: "15px !important",
            color: `${theme.colors.primary.blue500} !important`,
            backgroundColor: "inherit !important",
            border: `1px solid ${theme.colors.primary.blue500} !important`,
        },
    })
);
